module.exports = __webpack_public_path__ + "img/payment-failed-en.1170d83.png";